import axios from './axiosConfig';
import React, { createContext, useState, useEffect, useContext } from "react";
import { useParams, useLocation } from "react-router";
import { SocketContext } from './socketContext';
import { useAuth } from './AuthContext';
import { Modal } from 'antd';
import { useNavigate } from 'react-router';

// Create the context
const RezerwaContext = createContext();

// Create a provider component
const RezerwaProvider = ({ children }) => {
    const socket = useContext(SocketContext);
    const user = useAuth();
    const { rezerwaid } = useParams(); 
    const location = useLocation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);

    const [rezerwa, setrezerwa] = useState({
        changes: [],
        msr_rezerwa_id: rezerwaid,
        mode: rezerwaid === 'nowy' ? 'edit' : 'preview',
        reload: false,
        rezerwa_loading: false,
        rezerwa_data: {} 
    });

    // Update rezerwa ID on URL change
    useEffect(() => {
        setrezerwa(prev => ({ ...prev, msr_rezerwa_id: rezerwaid }));
    }, [rezerwaid]);


    // Fetch data for the rezerwa and block it
    useEffect(() => {
        setrezerwa(prev => ({ ...prev, rezerwa_loading: true }));

        const fetchData = async () => {
            try {
                const response = await axios.post("/rezerwa/get/data", {
                    rezerwaid: rezerwa.msr_rezerwa_id
                });

                setrezerwa(prev => ({ 
                    ...prev, 
                    rezerwa_loading: false, 
                    rezerwa_data: response.data 
                }));

            } catch (error) {
                console.error('Error fetching rezerwa data:', error);
                setrezerwa(prev => ({ ...prev, rezerwa_loading: false }));
            }
        };

        fetchData();
    }, [rezerwa.msr_rezerwa_id, rezerwa.reload]);

    return (
        <RezerwaContext.Provider value={{ rezerwa, setrezerwa }}>
            {children}
        </RezerwaContext.Provider>
    );
};

export { RezerwaContext, RezerwaProvider };
